import { createFileRoute } from '@tanstack/react-router';
import NewOrderPage from '../components/manager/NewOrderPage';

export const Route = createFileRoute('/staff/orders/new')({
  component: StaffNewOrderRoute,
});

function StaffNewOrderRoute() {
  return <NewOrderPage />;
}
